import template from './organizationGroupsAndBranchesEdit.template.html';

export default {
  bindings: {
    accounts: '=',
    onFinished: '&'
  },
  controller: class controller {
    constructor(
      $mdDialog,
      $mdMedia,
      $filter,
      $timeout,
      $rootScope,
      eventService,
      organizationService,
      uiService,
      Organization
    ) {
      'ngInject';
      /*
       * Controller Model
       * --------------------------------------------------------------------------------
       */
      var ctrl = this;
      ctrl.$mdDialog = $mdDialog;
      ctrl.$mdMedia = $mdMedia;
      ctrl.CurrentOrganization = null;
      ctrl.destroyWatch = null;

      /*
       * Methods
       * --------------------------------------------------------------------------------
       */
      this.initialize = function () {
        ctrl.CurrentOrganization = $rootScope.CurrentOrganization;
        ctrl.destroyWatch = eventService.onGroupsAndBranchesEdit(function (_params) {
          $mdDialog
            .show({
              targetEvent: _params.event,
              locals: {
                accounts: ctrl.accounts,
                organization: _params.organization
              },
              template,
              controllerAs: '$ctrl',
              controller: dialogController
            })
            .then(function (organization) {
              const updatedOrganization = _.pick(organization, ['id', 'idManagers']);
              organizationService.updateOrganization(updatedOrganization).then(function (data) {
                if (data.status) {
                  ctrl.onFinished({ organizationGaB: organization });
                  uiService.toast({
                    text: {
                      p1: 'Organization',
                      p2: organization.getName(),
                      p3: 'has been modified'
                    }
                  });
                }
              });
            });

          function dialogController($scope, $mdDialog, accounts, organization) {
            this.organization = organization;
            var self = this;
            this.chips = accounts.map(function (account, index) {
              return {
                id: account.id,
                name: account.getName(),
                email: account.user.eMail,
                image: account.user.avatar
              };
            });
            this.chipsAssigned = $filter('filter')(this.chips, function (c) {
              return self.organization.idManagers.indexOf(c.id) > -1;
            });
            this.chipsFilter = function (query) {
              return query
                ? $filter('filter')(this.chips, function (c) {
                    return c.name.toLowerCase().indexOf(query.toLowerCase()) > -1;
                  })
                : [];
            };
            this.confirm = function () {
              this.organization.idManagers = _.map(self.chipsAssigned, 'id');
              $mdDialog.hide(this.organization);
            };
            this.cancel = function () {
              $mdDialog.cancel();
            };
          }
        });
      };

      /*
       * Execute when all bindings are completed
       * --------------------------------------------------------------------------------
       */
      this.$onInit = function () {
        ctrl.initialize();
      };

      /*
       * Execute when bindings change
       * --------------------------------------------------------------------------------
       */
      this.$onChanges = function (changes) {
        if (changes.groupsAndBranches && changes.groupsAndBranches.currentValue) {
          ctrl.initialize();
        }
      };

      /*
       * Execute when component is not necessary anymore
       * --------------------------------------------------------------------------------
       */
      this.$onDestroy = function () {
        ctrl.destroyWatch();
      };
    }
  }
};
